export default __webpack_public_path__ + "static/group-tour-booking-system-9c310a6f626c6e161dc9f1636c7904e9.png";